import { render, staticRenderFns } from "./productShow.vue?vue&type=template&id=b3b4484c&scoped=true"
import script from "./productShow.vue?vue&type=script&lang=js"
export * from "./productShow.vue?vue&type=script&lang=js"
import style0 from "./productShow.vue?vue&type=style&index=0&id=b3b4484c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b4484c",
  null
  
)

export default component.exports